<p-heading class="title" [size]="'x-large'" [tag]="'h3'">Budget Corrections</p-heading>

<p-divider aria-hidden="true" />

<section class="section">
  <p-heading class="section-heading" [size]="'medium'" [tag]="'h4'">
    <div class="content">
      <p-icon [source]="'assets/icons/add-circle.svg'" />
      <span>Create New Budget Correction</span>
    </div>
  </p-heading>

  <ng-container
    *ngrxLet="createBudgetCorrectionData$ as data; error as dataError; suspenseTpl: spinner"
  >
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadCreateBudgetCorrectionData()"
      >
        Reload Create New Budget Correction
      </p-button-pure>
    </div>

    <form *ngIf="!dataError && data" class="form" [formGroup]="form" (ngSubmit)="submit()">
      <p-select-wrapper
        *ngrxLet="form.controls.participants as control"
        [filter]="true"
        [label]="'People'"
        [message]="control.errors?.['message'] ?? ''"
        [state]="control.touched && control.errors ? 'error' : 'none'"
      >
        <select [attr.required]="true" [formControl]="control">
          <option
            *ngFor="
              let user of data.users | opaFilterSelectedUsers: control.value;
              trackBy: trackUser
            "
            [value]="user | opaJoinUsers: control.value"
          >
            {{ user.firstName }} {{ user.lastName }}
          </option>
        </select>
      </p-select-wrapper>

      <ng-container *ngrxLet="form.controls.participants.value | opaStringSplit: ',' as userIds">
        <div *ngIf="userIds && userIds.length > 0">
          <p-text [color]="'contrast-medium'">{{ userIds.length }} selected:</p-text>

          <div *ngFor="let userId of userIds">
            <p-button-pure
              *ngrxLet="userId | opaFindUser: data.users as user"
              [aria]="{
                'aria-label':
                  (user ? user.firstName + ' ' + user.lastName : userId) + ' (remove selected)',
              }"
              [iconSource]="'assets/icons/close.svg'"
              [type]="'button'"
              (click)="removeParticipant(userId)"
            >
              <ng-container *ngIf="user">{{ user.firstName }} {{ user.lastName }}</ng-container>
              <ng-container *ngIf="!user">{{ userId }}</ng-container>
            </p-button-pure>
          </div>
        </div>
      </ng-container>

      <p-text-field-wrapper
        *ngrxLet="form.controls.amount as control"
        [label]="'Correction Amount'"
        [message]="control.errors?.['message'] ?? ''"
        [state]="control.touched && control.errors ? 'error' : 'none'"
        [unit]="defaultCurrencyCode"
        [unitPosition]="'suffix'"
      >
        <input type="number" [attr.required]="true" [formControl]="control" />
      </p-text-field-wrapper>

      <p-textarea-wrapper
        *ngrxLet="form.controls.description as control"
        [label]="'Description (Optional)'"
        [message]="control.errors?.['message'] ?? ''"
        [showCounter]="true"
        [state]="control.touched && control.errors ? 'error' : 'none'"
      >
        <textarea [formControl]="control" [maxlength]="textareaMaxLength"></textarea>
      </p-textarea-wrapper>

      <div class="actions">
        <p-button
          [icon]="'none'"
          [loading]="data.submitting"
          [type]="'submit'"
          [variant]="'primary'"
        >
          Create Budget Correction
        </p-button>
      </div>
    </form>
  </ng-container>
</section>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>
